<div *ngIf="isLoading" class="loading">
    <div class="loading_txt">
        <div class="load_txt">{{"startorderUk.loadinglabel" | cxTranslate}}</div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>
<div class="reviewOrderBody_container" id="OM_reviewOrder" *ngIf="enablePage?.showReviewPage && reviewPageData">
    <div class="col-xs-6 cart_neworderheader pb-4">New {{seasonValue | seasonspilt}} <ng-container
            *ngIf="prepreseason==seasonValue;else normaltext">Pre-order</ng-container><ng-template
            #normaltext>Order</ng-template></div>
    <section class="col-xs-12 OM_productDoseSection">
        <button class="OM_backText" (click)="handleOnBackBtnClick()">
            <img class="OM_backArrow" alt="Previous screen"
                src="../../../assets/images/blackarrow.png">{{"startorderUk.reviewpage.backtodeliveryweek" |
            cxTranslate}}</button>
        <div class="col-xs-12 OM_selectline"></div>
        <div class="clearboth"></div>

        <!-- location details starts -->

        <div class="reviewOrder_locContainer">
            <input type="hidden" name="requestType" value="CR">
            <!-- location 1 starts -->
            <div class="locationDiv">
                <div class="locDiv col-xs-12 no-pad" id="prodLocation1"
                    *ngFor="let location of reviewPageData.reviewData?.cartEntries; let i= index">
                    <div id="deliveylocation">
                        <div class="row">
                            <div class="col-xs-12">
                                <div id="deliveryparent">
                                    <div class=" col-xs-12 no-padding"
                                        [ngClass]="seasonValue==prepreseason?'prepredelivery':''">


                                        <div class="preprebox no-margin"
                                            [ngClass]="seasonValue==prepreseason?'col-xs-8':'col-xs-12'">
                                            <div [innerHtml]="reviewcontent?.content"></div>
                                            <div class="col-xs-12 inputSection prepredelivery">
                                                <div class="inputParent col-xs-8 no-pad">
                                                    <label class="prelabel">{{"startorderUk.reviewpage.firstname" |
                                                        cxTranslate}}</label> <input type="text"
                                                        [ngClass]="location.deliveryContact.firstNameErrorMsg ? 'has-error' : ''"
                                                        name="prepre{{i}}" class="dynFirstname col-xs-6 form-control"
                                                        id="" [(ngModel)]="location.deliveryContact.name"
                                                        (keyup)="checkForErrrors()"
                                                        (ngModelChange)="handleOnInputValueChange($event,'firstName',i)"
                                                        autocomplete="no">
                                                    <span
                                                        class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                                        *ngIf="location.deliveryContact.firstNameErrorMsg"></span>
                                                    <label id="prepre{{i}}" class="error help-block" for="{{i}}"
                                                        *ngIf="location.deliveryContact.firstNameErrorMsg ">{{location.deliveryContact.firstNameErrorMsg}}</label>
                                                    <!-- Please enter only letters -->
                                                </div>
                                                <div class="inputParent"
                                                    [ngClass]="location.deliveryContact.emailErrorMsg ? 'has-error' : ''">
                                                    <label class="prelabel">{{"startorderUk.reviewpage.email" |
                                                        cxTranslate}}</label> <input type="text" name="prepre{{i}}"
                                                        [(ngModel)]="location.deliveryContact.email"
                                                        (keyup)="checkForErrrors()"
                                                        (ngModelChange)="handleOnInputValueChange($event,'email',i)"
                                                        class="dynemail form-control" id="" autocomplete="no">
                                                    <span *ngIf="location.deliveryContact.emailErrorMsg"
                                                        class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                    <label id="prepre{{i}}" class="error help-block" for="{{i}}"
                                                        *ngIf="location.deliveryContact.emailErrorMsg">{{location.deliveryContact.emailErrorMsg}}</label>
                                                </div>
                                                <div class="">
                                                    <div class="col-xs-6 no-pad inputParent"
                                                        [ngClass]="location.deliveryContact.phoneNumberErrorMsg ? 'has-error' : ''">
                                                        <label class="prelabel">{{"startorderUk.reviewpage.phnnum" |
                                                            cxTranslate}}</label> <input type="text" name="prepre{{i}}"
                                                            class="dynphno form-control" id=""
                                                            (keyup)="checkForErrrors()"
                                                            [(ngModel)]="location.deliveryContact.phone"
                                                            (ngModelChange)="handleOnInputValueChange($event,'phone',i)"
                                                            maxlength="11" autocomplete="no">
                                                        <span
                                                            class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                                            *ngIf="location.deliveryContact.phoneNumberErrorMsg"></span>
                                                        <label id="prepre{{i}}" class="error help-block" for="{{i}}"
                                                            *ngIf="location.deliveryContact.phoneNumberErrorMsg">
                                                            {{location.deliveryContact.phoneNumberErrorMsg}}</label>
                                                        <!-- Please enter only Numbers -->
                                                    </div>
                                                    <div class="col-xs-6 no-right-pad inputParent">
                                                        <label
                                                            class="prelabel preext left20">{{"startorderUk.reviewpage.ext"
                                                            | cxTranslate}}</label> <input type="text"
                                                            name="prepre{{i}}" class="dynphnoextn form-control" id=""
                                                            [(ngModel)]="location.deliveryContact.ext" maxlength="4"
                                                            autocomplete="no"
                                                            (ngModelChange)="handleOnInputValueChange($event,'ext',i)">
                                                        <span
                                                            class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                                            *ngIf="location.deliveryContact.phoneextErrorMsg"></span>
                                                        <label id="prepre{{i}}" class="error help-block" for="{{i}}"
                                                            *ngIf="location.deliveryContact.phoneextErrorMsg">
                                                            {{location.deliveryContact.phoneextErrorMsg}}</label>
                                                    </div>
                                                </div>
                                                <!-- <div class="userInfoHeader">NHS Code</div> -->
                                                <!-- <div class="inputParent col-xs-8 no-pad no-margin-bottom">
                                                    <label class="prelabel">{{"startorderUk.reviewpage.nhscode" |
                                                        cxTranslate}}</label> <input type="text" name="prepre{{i}}"
                                                        class="form-control dynnhsreview" [(ngModel)]="location.nhsCode"
                                                        (ngModelChange)="handleOnInputValueChange($event,'nhs',i)"
                                                        maxlength="6" autocomplete="no" value="">
                                                    <span
                                                        class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                                        *ngIf="location.nhsErrorMsg"></span>
                                                    <label id="prepre{{i}}" class="error help-block" for="{{i}}"
                                                        *ngIf="location.nhsErrorMsg">{{location.nhsErrorMsg}}</label>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class=" no-padding"
                                            [ngClass]="seasonValue==prepreseason?'col-xs-4 ':'col-xs-12 prepredelivery horizontalview'">
                                            <div class="accountbox">
                                                <div class="userInfoHeader">Account Address</div>
                                                <ng-container *ngFor="let shipping of reviewPageData.shippingData;">
                                                    <div class="accounttext"
                                                        *ngIf="location.shippinglocID==shipping.locID">
                                                        {{shipping?.locname}}<br> {{shipping?.address}}<br>
                                                        {{shipping?.state}}
                                                    </div>
                                                </ng-container>

                                            </div>
                                            <div class="accountbox">



                                                <div [innerHtml]="reviewcontent?.LargeText2"></div>
                                                <div class="rightText3 float_left"
                                                    *ngIf="reviewPageData.reviewData.salesContact">
                                                    {{reviewPageData.reviewData.salesContact.name}}<br>{{reviewPageData.reviewData.salesContact.email}}<br>{{reviewPageData.reviewData.salesContact.phone}}
                                                    Ext. {{reviewPageData.reviewData.salesContact.ext}}</div>

                                                <div class="clearboth"></div>



                                            </div>
                                            @if(seasonValue!=prepreseason){
                                            <div class="accountbox">


                                                <div class=" float_left orderbox">
                                                    <div class="rightText4 no-margin">
                                                        {{"startorderUk.reviewpage.orderterms" | cxTranslate}}</div>
                                                    <div class="rightText5">{{"startorderUk.reviewpage.saleorreturn" |
                                                        cxTranslate}}</div>
                                                    <div class="rightText6" *ngIf="seasonValue==preseason">
                                                        {{"startorderUk.reviewpage.sormessage1" | cxTranslate}}<span>
                                                            <ng-container
                                                                *ngIf="reviewPageData.priceResponse.SOR;else zersor1">{{reviewPageData.priceResponse.SOR
                                                                | number}}</ng-container>
                                                            <ng-template #zersor1>0</ng-template>%</span>
                                                        {{"startorderUk.reviewpage.sormessage2" | cxTranslate}}.</div>
                                                        <div class="rightText6" *ngIf="seasonValue==inseason">
                                                            <ng-container *ngIf="reviewPageData.priceResponse.SOR!='0';else zersor1">
                                                            {{"startorderUk.reviewpage.sormessage1" | cxTranslate}}
                                                              {{reviewPageData.priceResponse.SOR | number}}% {{"startorderUk.reviewpage.sormessage2" | cxTranslate}}.
                                                        </ng-container>
                                                        <ng-template #zersor1>Sale or return does not apply to in-season orders. All in-season orders are not eligible for return.</ng-template>
                                                    </div>
                                                        

                                                    <div class="rightText7">Credit days</div>
                                                    <div class="rightText8">
                                                        {{"startorderUk.reviewpage.creditmessage1" | cxTranslate}}<span>
                                                            {{reviewPageData.priceResponse.creditDays}}</span>
                                                        {{"startorderUk.reviewpage.creditmessage2" | cxTranslate}}.
                                                    </div>
                                                </div>
                                                <input type="hidden" id="business-org_type" value="GP Medical Practice">



                                            </div>
                                            }
                                        </div>



                                    </div>
                                    @if(seasonValue==prepreseason){

                                    <div class="prepredelivery col-xs-12  preprebox">

                                        <div class="col-xs-7 no-padding">
                                            <div class="col-xs-12 no-padding licencetext margin-B20"
                                                [innerHtml]="reviewcontent?.LargeText1"></div>
                                            <div class="inputParent col-xs-6 no-padding-right"
                                                [ngClass]="location.licenseInfo.nameErrorMsg ? 'has-error' : ''">
                                                <label class="prelabel left20">{{"startorderUk.reviewpage.licensename" |
                                                    cxTranslate}}</label> <input type="text" name="{{i}}"
                                                    class="col-xs-6 form-control liname" id=""
                                                    (keyup)="checkForErrrors()" [(ngModel)]="location.licenseInfo.name"
                                                    (ngModelChange)="handleOnInputValueChange($event,'licenseInfoName',i)"
                                                    autocomplete="no">
                                                <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                                    *ngIf="location.licenseInfo.nameErrorMsg"></span>
                                                <label id="{{i}}" class="error help-block" for="{{i}}"
                                                    *ngIf="location.licenseInfo.nameErrorMsg">
                                                    {{location.licenseInfo.nameErrorMsg}}</label>
                                                <!-- Please enter only letters -->
                                            </div>
                                            <div class="inputParent col-xs-6 positionrel "
                                                [ngClass]="location.licenseInfo.numberErrorMsg ? 'has-error' : ''">
                                                <label class="prelabel left20">{{"startorderUk.reviewpage.licensenum" |
                                                    cxTranslate}}</label> <input type="text" name="{{i}}"
                                                    class="form-control lino" id=""
                                                    [(ngModel)]="location.licenseInfo.number"
                                                    (keyup)="checkForErrrors()"
                                                    (ngModelChange)="handleOnInputValueChange($event,'licenseInfoNumber',i)"
                                                    maxlength="15" autocomplete="no">
                                                <span *ngIf="location.licenseInfo.numberErrorMsg"
                                                    class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                <label id="{{i}}" class="error help-block" for="{{i}}"
                                                    *ngIf="location.licenseInfo.numberErrorMsg">
                                                    {{location.licenseInfo.numberErrorMsg}}</label>
                                            </div>
                                            <div class="licence_checkboxparent col-xs-12">
                                                <label class="checkbox-button inputParent" id="license_check"> <input
                                                        type="checkbox" name="checkbox[0]"
                                                        (change)="handlepreprebookvalidation($event)"
                                                        [(ngModel)]="location.licenseInfo.checked"
                                                        (click)=locationlevelcheck($event,i)
                                                        (ngModelChange)="handleOnInputValueChange($event,'checkbox',i);validateForm(i)"
                                                        class="review_checkbox licenceCheckbox" id=""> <span
                                                        class="checkbox-button_control"></span>
                                                    <label
                                                        class="checkboxtext">{{"startorderUk.reviewpage.licenseconfirmmsg"
                                                        | cxTranslate}}</label>

                                                </label>
                                                <label id="checkbox[1]-error" class="error help-block" for="checkbox[1]"
                                                    *ngIf="location.licenseInfo.checkboxErrorMsg">{{location.licenseInfo.checkboxErrorMsg}}</label>
                                            </div>
                                        </div>
                                        <div class="col-xs-5 no-padding">
                                            <div class="userInfoHeader">{{"startorderUk.reviewpage.ponumberfull" |
                                                cxTranslate}}</div>
                                            <div class=" userInfoDetails pomargin">Please enter your purchase order
                                                number, if required.</div>
                                            <div class="inputParent col-xs-12 no-pad no-margin-bottom">
                                                <label class="prelabel">{{"startorderUk.reviewpage.ponumber" |
                                                    cxTranslate}}</label> <input type="text" name="{{i}}"
                                                    class="form-control" id="" value="" maxlength="10" autocomplete="no"
                                                    [(ngModel)]="location.poNumber">
                                            </div>
                                        </div>
                                    </div>
                                    }@else{
                                    <div class="prepredelivery col-xs-12  preprebox">

                                        <div class="col-xs-12 no-padding">
                                            <div class="col-xs-12 no-padding licencetext margin-B20"
                                                [innerHtml]="reviewcontent?.LargeText1"></div>
                                            <div class="inputParent col-xs-6 no-padding-right"
                                                [ngClass]="location.licenseInfo.nameErrorMsg ? 'has-error' : ''">
                                                <label class="prelabel left20">{{"startorderUk.reviewpage.licensename" |
                                                    cxTranslate}}</label> <input type="text" name="{{i}}"
                                                    class="col-xs-6 form-control liname" id=""
                                                    (keyup)="checkForErrrors()" [(ngModel)]="location.licenseInfo.name"
                                                    (ngModelChange)="handleOnInputValueChange($event,'licenseInfoName',i)"
                                                    autocomplete="no">
                                                <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                                    *ngIf="location.licenseInfo.nameErrorMsg"></span>
                                                <label id="{{i}}" class="error help-block" for="{{i}}"
                                                    *ngIf="location.licenseInfo.nameErrorMsg">
                                                    {{location.licenseInfo.nameErrorMsg}}</label>
                                                <!-- Please enter only letters -->
                                            </div>
                                            <div class="inputParent col-xs-6 positionrel "
                                                [ngClass]="location.licenseInfo.numberErrorMsg ? 'has-error' : ''">
                                                <label class="prelabel left20">{{"startorderUk.reviewpage.licensenum" |
                                                    cxTranslate}}</label> <input type="text" name="{{i}}"
                                                    class="form-control lino" id=""
                                                    [(ngModel)]="location.licenseInfo.number"
                                                    (keyup)="checkForErrrors()"
                                                    (ngModelChange)="handleOnInputValueChange($event,'licenseInfoNumber',i)"
                                                    maxlength="15" autocomplete="no">
                                                <span *ngIf="location.licenseInfo.numberErrorMsg"
                                                    class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                <label id="{{i}}" class="error help-block" for="{{i}}"
                                                    *ngIf="location.licenseInfo.numberErrorMsg">
                                                    {{location.licenseInfo.numberErrorMsg}}</label>
                                            </div>
                                            <div class="licence_checkboxparent col-xs-12">
                                                <label class="checkbox-button inputParent" id="license_check"> <input
                                                        type="checkbox" name="checkbox[0]"
                                                        (change)="handlepreprebookvalidation($event)"
                                                        [(ngModel)]="location.licenseInfo.checked"
                                                        (click)=locationlevelcheck($event,i)
                                                        (ngModelChange)="handleOnInputValueChange($event,'checkbox',i);validateForm(i)"
                                                        class="review_checkbox licenceCheckbox" id=""> <span
                                                        class="checkbox-button_control"></span>
                                                    <label
                                                        class="checkboxtext">{{"startorderUk.reviewpage.licenseconfirmmsg"
                                                        | cxTranslate}}</label>

                                                </label>
                                                <label id="checkbox[1]-error" class="error help-block" for="checkbox[1]"
                                                    *ngIf="location.licenseInfo.checkboxErrorMsg">{{location.licenseInfo.checkboxErrorMsg}}</label>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="prepredelivery col-xs-12  preprebox">
                                        <div class="col-xs-12 no-padding">
                                            <div class="userInfoHeader ">{{"startorderUk.reviewpage.ponumberfull" |
                                                cxTranslate}}</div>
                                            <div class="userInfoDetails margin-B20">Please enter your purchase order
                                                number, if required.</div>

                                            <div class="inputParent col-xs-12 no-pad no-margin-bottom">
                                                <label class="prelabel">{{"startorderUk.reviewpage.ponumber" |
                                                    cxTranslate}}</label> <input type="text" name="{{i}}"
                                                    class="form-control" id="" value="" maxlength="10" autocomplete="no"
                                                    [(ngModel)]="location.poNumber">
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    <form #weekselectionform="ngForm">

                                        <div class="deliveylocation">


                                            <div class="greyline"></div>

                                            <!--  <div class="row col-xs-12 no-padding" *ngIf="seasonValue!=prepreseason">
                                                <ng-container *ngFor="let shipping of reviewPageData.shippingData;" >
                                                <div class="col-xs-12 locationNumber" *ngIf="location.shippinglocID==shipping.locID">{{shipping?.locname}}, {{shipping?.address}}, {{shipping?.state}}
                                                     </div>
                                                    </ng-container>
                                            </div> -->

                                            <div class=" col-xs-12"
                                                [ngClass]="seasonValue==prepreseason?'prepreboxdelivery':'border_box'">
                                                <div class="row review_Header_Row">
                                                    @if(seasonValue!=prepreseason){
                                                    <div class="prodTableHeader">{{"startorderUk.reviewpage.products" |
                                                        cxTranslate}}</div>
                                                    }
                                                    @if(seasonValue==inseason){
                                                    <div class="col-xs-1 deliverycol locationtext margin-B30">Location
                                                    </div>
                                                    <div class="col-xs-1 deliverycol1 dashsymbol">|</div>
                                                    <div class="col-xs-11 deliverycol2 locationdetail margin-B30">
                                                        <span>{{shippingData[i].locname}}</span>
                                                        <span>{{shippingData[i].address}}</span>
                                                        <span>{{shippingData[i].state}}</span>
                                                    </div>
                                                    }

                                                </div>
                                                <div class="row margin-B20">
                                                    <div class="seasonvalue">{{reviewdelivery}} Delivery Dates</div>
                                                    <div class="no-padding deliveyweek">(week commencing)</div>
                                                    <!-- HARDCORED -->

                                                </div>

                                                <div class="row">
                                                    <div class="col-xs-12 no-padding">

                                                        <table class="deliverytable">
                                                            <ng-container
                                                                *ngFor=" let prodData of location.products; let p= index">
                                                                <ng-container
                                                                    *ngIf="(prodData.baseName=='AQIV' || prodData.baseName=='Aujemflu') && prodData.qty !== 0">
                                                                    <tr>
                                                                        <ng-container
                                                                            *ngIf="reviewPageData.productList[0].baseProductName  == 'aTIV - 10 Pack' || reviewPageData.productList[0].baseProductName  == 'Aujemflu - 10 Pack'">
                                                                            @if(reviewPageData?.productList[0].baseName=='Aujemflu'){
                                                                            <td class="productheader " colspan="15">
                                                                                {{reviewPageData?.productList[0].baseName}}
                                                                                (aIIVc)<span class="tenpack">
                                                                                    {{"startorderUk.deliveryweek.10packlabel"
                                                                                    | cxTranslate}}
                                                                                </span>
                                                                                <div class="listprice">
                                                                                    {{reviewcontent?.solutiontype}}
                                                                                </div>

                                                                                <div class="priceDetail">Customer Price
                                                                                    &#163;<span>{{reviewPageData?.productList[0]?.priceData?.value
                                                                                        | number:'1.2' }}</span> (ex
                                                                                    VAT)</div>
                                                                            </td>
                                                                            }@else{
                                                                            <td class="productheader " colspan="15">
                                                                                {{"startorderUk.deliveryweek.ativ" |
                                                                                cxTranslate}}<span
                                                                                    *ngIf="seasonValue==prepreseason">
                                                                                    (aIIV)</span><span
                                                                                    *ngIf="seasonValue!=prepreseason"
                                                                                    class="tenpack">
                                                                                    {{"startorderUk.deliveryweek.10packlabel"
                                                                                    | cxTranslate}}</span>
                                                                                @if(seasonValue==inseason){


                                                                                <div class="listprice">
                                                                                    {{reviewcontent?.itemPerPack}}</div>

                                                                                <div class="priceDetail ">Customer Price
                                                                                    &#163;<span>{{reviewPageData?.productList[0]?.priceData?.value
                                                                                        | number:'1.2' }}</span> (ex
                                                                                    VAT)</div>
                                                                                }

                                                                            </td>
                                                                            }



                                                                            <!--  <td class="productheader deliverycol">
                                                                                {{"startorderUk.deliveryweek.ativ" | cxTranslate}}<span
                                                                                *ngIf="seasonValue==prepreseason"> (aIIV)</span><br />
                                                                                <span class="tenpack">{{"startorderUk.deliveryweek.10packlabel" | cxTranslate}}<span class="verticlDivisiondelivery" *ngIf="seasonValue!=prepreseason"></span>
                                                <span class="priceDetail"  *ngIf="seasonValue!=prepreseason">&#163;<span >{{reviewPageData?.productList[0]?.priceData?.value | number:'1.2'}}</span> per dose</span></span>
                                                <br><span class="delivery_ProductDesc" *ngIf="seasonValue!=prepreseason">{{"startorderUk.deliveryweek.65yearslabel" | cxTranslate}}</span><span class="delivery_ProductDesc" *ngIf="seasonValue==prepreseason">(50+ years)</span><span  class="imagetooltip deliverytooltip"  *ngIf="seasonValue!=prepreseason"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <mask id="mask0_1657_7057" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
                                                    <rect y="0.420013" width="16" height="16" fill="#D9D9D9"/>
                                                    </mask>
                                                    <g mask="url(#mask0_1657_7057)">
                                                    <path d="M7.3335 11.7533H8.66683V7.75335H7.3335V11.7533ZM8.00016 6.42001C8.18905 6.42001 8.34738 6.35612 8.47516 6.22835C8.60294 6.10057 8.66683 5.94223 8.66683 5.75335C8.66683 5.56446 8.60294 5.40612 8.47516 5.27835C8.34738 5.15057 8.18905 5.08668 8.00016 5.08668C7.81127 5.08668 7.65294 5.15057 7.52516 5.27835C7.39738 5.40612 7.3335 5.56446 7.3335 5.75335C7.3335 5.94223 7.39738 6.10057 7.52516 6.22835C7.65294 6.35612 7.81127 6.42001 8.00016 6.42001ZM8.00016 15.0867C7.07794 15.0867 6.21127 14.9117 5.40016 14.5617C4.58905 14.2117 3.8835 13.7367 3.2835 13.1367C2.6835 12.5367 2.2085 11.8311 1.8585 11.02C1.5085 10.2089 1.3335 9.34223 1.3335 8.42001C1.3335 7.49779 1.5085 6.63112 1.8585 5.82001C2.2085 5.0089 2.6835 4.30335 3.2835 3.70335C3.8835 3.10335 4.58905 2.62835 5.40016 2.27835C6.21127 1.92835 7.07794 1.75335 8.00016 1.75335C8.92238 1.75335 9.78905 1.92835 10.6002 2.27835C11.4113 2.62835 12.1168 3.10335 12.7168 3.70335C13.3168 4.30335 13.7918 5.0089 14.1418 5.82001C14.4918 6.63112 14.6668 7.49779 14.6668 8.42001C14.6668 9.34223 14.4918 10.2089 14.1418 11.02C13.7918 11.8311 13.3168 12.5367 12.7168 13.1367C12.1168 13.7367 11.4113 14.2117 10.6002 14.5617C9.78905 14.9117 8.92238 15.0867 8.00016 15.0867ZM8.00016 13.7533C9.48905 13.7533 10.7502 13.2367 11.7835 12.2033C12.8168 11.17 13.3335 9.9089 13.3335 8.42001C13.3335 6.93112 12.8168 5.67001 11.7835 4.63668C10.7502 3.60335 9.48905 3.08668 8.00016 3.08668C6.51127 3.08668 5.25016 3.60335 4.21683 4.63668C3.1835 5.67001 2.66683 6.93112 2.66683 8.42001C2.66683 9.9089 3.1835 11.17 4.21683 12.2033C5.25016 13.2367 6.51127 13.7533 8.00016 13.7533Z" fill="var(--lightgrey)"/>
                                                    </g>
                                                    </svg><span class="tooltiptext">{{"startorderUk.deliveryweek.ativtootip" | cxTranslate}}</span></span></td> -->
                                                                            <!-- <td class="middletext deliverycol "><span
                                                                                    class="tenpack">10-pack</span><br /><span
                                                                                    class="delivery_ProductDesc">(6
                                                                                    months &amp; above)</span></td>
                                                                            <td class="deliverycol1"></td> -->
                                                                        </ng-container>

                                                                    </tr>
                                                                    <tr id="month">

                                                                        <ng-container
                                                                            *ngFor="let deliverydate of deliverySlotArray;let d=index">
                                                                            <ng-container *ngIf="d!= maxDeliverySlots">
                                                                                <td class=" datetext">
                                                                                    {{deliverydate.month}}
                                                                                </td>
                                                                            </ng-container>
                                                                            <ng-container *ngIf="d == maxDeliverySlots">
                                                                                <td class="gapbet"></td>
                                                                                <td class=" datetext">
                                                                                    {{deliverydate.month}}
                                                                                </td>

                                                                            </ng-container>

                                                                        </ng-container>

                                                                        <td class="gapdose"></td>
                                                                        <td class=" dosestext">Doses</td>
                                                                        <td class="greentick"></td>

                                                                    </tr>
                                                                    <tr class="">

                                                                        <ng-container
                                                                            *ngFor="let deliverydate of deliverySlotArray;let d=index">
                                                                            <ng-container
                                                                                *ngIf="d!=maxDeliverySlots;else gap">
                                                                                <td class=" datetext">
                                                                                    {{deliverydate.date}}</td>
                                                                            </ng-container>
                                                                            <ng-template #gap>
                                                                                <td class="gapbet"></td>
                                                                                <td class=" datetext">
                                                                                    {{deliverydate.date}}</td>
                                                                            </ng-template>

                                                                        </ng-container>


                                                                        <td class="gapdose"></td>
                                                                        <td class=" dosestext">
                                                                            {{"startorderUk.deliveryweek.ordered" |
                                                                            cxTranslate}}</td>
                                                                        <td class="greentick"></td>

                                                                    </tr>

                                                                    <tr id="delivey_aQIV">







                                                                        <ng-container
                                                                            *ngFor="let productinput1 of prodData.deliverySlots;let j=index">
                                                                            <ng-container
                                                                                *ngIf="j!=maxDeliverySlots;else product1gap">
                                                                                <td class="deliverydate_input">
                                                                                    <input type="text"
                                                                                        [ngClass]="prodData.deliverySlots[j].available=='N'?'at_capacity':''"
                                                                                        [disabled]="prodData.deliverySlots[j].available=='N' || prodData.deliverySlots[j].disablerule==true"
                                                                                        value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                                        autocomplete="off" readonly
                                                                                        class="delivery_data  aqivcount form-control dynvacinedoses"
                                                                                        id="aqivfirst[{{i}}][{{j}}]"
                                                                                        name="createOrderData[{{i}}].createOrderProductData[0].createOrderDeliverySlotData[{{j}}]].quantity" /><span
                                                                                        class="glyphicon form-control-erroricon"></span>
                                                                                </td>
                                                                            </ng-container>
                                                                            <ng-template #product1gap>
                                                                                <td class="gapbet"></td>
                                                                                <td class="deliverydate_input">
                                                                                    <input type="text"
                                                                                        [ngClass]="prodData.deliverySlots[j].available=='N'?'at_capacity':''"
                                                                                        [disabled]="prodData.deliverySlots[j].available=='N' || prodData.deliverySlots[j].disablerule==true"
                                                                                        autocomplete="off" readonly
                                                                                        value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                                        class="delivery_data  aqivcount form-control dynvacinedoses"
                                                                                        id="aqivfirst[{{i}}][{{j}}]"
                                                                                        name="createOrderData[{{i}}].createOrderProductData[0].createOrderDeliverySlotData[{{j}}]].quantity" /><span
                                                                                        class="glyphicon form-control-erroricon"></span>
                                                                                </td>
                                                                            </ng-template>

                                                                        </ng-container>

                                                                        <td class="gapdose">
                                                                            <div class="totalcost">Total (ex VAT)</div>
                                                                        </td>
                                                                        <td class="deliveryallocated_input dosesbox">
                                                                            <input type="text" autocomplete="off"
                                                                                value="{{prodData.qty | number}}"
                                                                                class=" delivery_data aqiv_allocated form-control dynallacted"
                                                                                id="aqivallocated[{{i}}]" readonly
                                                                                name="deliveryweek.aqivallocated[{{i}}]"
                                                                                readonly value="" />
                                                                            <div *ngIf="seasonValue!=prepreseason">
                                                                                <input autocomplete="off"
                                                                                    class=" delivery_data aqivtotal form-control "
                                                                                    name="deliveryweek.aqivtotalcost[{{i}}]"
                                                                                    id="aqivtotalcost[{{i}}]"
                                                                                    value="&#163;{{prodData.qty * reviewPageData?.productList[0]?.priceData?.value | number:'1.2'}}"
                                                                                    readonly />
                                                                            </div>
                                                                        </td>
                                                                        <!--<td class="greentick">
                                                                            </td> -->
                                                                    </tr>

                                                                </ng-container>
                                                                <ng-container
                                                                    *ngIf="prodData.baseName=='QIVC' && prodData.qty !== 0">
                                                                    <tr>
                                                                        <ng-container
                                                                            *ngIf="reviewPageData.productList[1].baseProductName == 'TIVc - 10 Pack'">
                                                                            <td class="productheader " colspan="15">
                                                                                {{"startorderUk.deliveryweek.tivc" |
                                                                                cxTranslate}}<span> (IIVc)</span>
                                                                                <span class="tenpack">
                                                                                    {{"startorderUk.deliveryweek.10packlabel"
                                                                                    | cxTranslate}}</span>

                                                                                @if(seasonValue==preseason){
                                                                                <div class="listprice">
                                                                                    {{reviewcontent?.headline}}</div>

                                                                                <div class="priceDetail">Customer Price
                                                                                    &#163;<span>{{reviewPageData?.productList[1]?.priceData?.value
                                                                                        | number:'1.2' }}</span> (ex
                                                                                    VAT)</div>
                                                                                }@else if(seasonValue==inseason){
                                                                                <div class="listprice">
                                                                                    {{reviewcontent?.itemPerPack}}</div>

                                                                                <div class="priceDetail ">Customer Price
                                                                                    &#163;<span>{{reviewPageData?.productList[1]?.priceData?.value
                                                                                        | number:'1.2' }}</span> (ex
                                                                                    VAT)</div>
                                                                                }
                                                                            </td>
                                                                        </ng-container>

                                                                    </tr>
                                                                    <tr id="month">

                                                                        <ng-container
                                                                            *ngFor="let deliverydate of deliverySlotArray;let d=index">
                                                                            <ng-container *ngIf="d!= maxDeliverySlots">
                                                                                <td class=" datetext">
                                                                                    {{deliverydate.month}}
                                                                                </td>
                                                                            </ng-container>
                                                                            <ng-container *ngIf="d == maxDeliverySlots">
                                                                                <td class="gapbet"></td>
                                                                                <td class=" datetext">
                                                                                    {{deliverydate.month}}
                                                                                </td>

                                                                            </ng-container>

                                                                        </ng-container>

                                                                        <td class="gapdose"></td>
                                                                        <td class=" dosestext">Doses</td>
                                                                        <td class="greentick"></td>

                                                                    </tr>
                                                                    <tr class="">

                                                                        <ng-container
                                                                            *ngFor="let deliverydate of deliverySlotArray;let d=index">
                                                                            <ng-container
                                                                                *ngIf="d!=maxDeliverySlots;else gap">
                                                                                <td class=" datetext">
                                                                                    {{deliverydate.date}}</td>
                                                                            </ng-container>
                                                                            <ng-template #gap>
                                                                                <td class="gapbet"></td>
                                                                                <td class=" datetext">
                                                                                    {{deliverydate.date}}</td>
                                                                            </ng-template>

                                                                        </ng-container>


                                                                        <td class="gapdose"></td>
                                                                        <td class=" dosestext">
                                                                            {{"startorderUk.deliveryweek.ordered" |
                                                                            cxTranslate}}</td>
                                                                        <td class="greentick"></td>

                                                                    </tr>
                                                                    <tr id="delivey_QIVc">




                                                                        <ng-container
                                                                            *ngFor="let productinput2 of prodData.deliverySlots;let j=index">
                                                                            <ng-container
                                                                                *ngIf="j!=maxDeliverySlots;else product2gap">
                                                                                <td class="deliverydate_input">
                                                                                    <input type="text"
                                                                                        [ngClass]="prodData.deliverySlots[j].available=='N'?'at_capacity':''"
                                                                                        [disabled]="prodData.deliverySlots[j].available=='N' || prodData.deliverySlots[j].disablerule==true"
                                                                                        autocomplete="off" readonly
                                                                                        value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                                        class="delivery_data qivccount  form-control dynvacinedoses"
                                                                                        id="qivcfirst[{{i}}][{{j}}]"
                                                                                        name="createOrderData[{{i}}].createOrderProductData[1].createOrderDeliverySlotData[{{j}}].quantity" /><span
                                                                                        class="glyphicon form-control-erroricon"></span>
                                                                                </td>
                                                                            </ng-container>
                                                                            <ng-template #product2gap>
                                                                                <td class="gapbet"></td>
                                                                                <td class="deliverydate_input">
                                                                                    <input type="text"
                                                                                        [ngClass]="prodData.deliverySlots[j].available=='N'?'at_capacity':''"
                                                                                        [disabled]="prodData.deliverySlots[j].available=='N' || prodData.deliverySlots[j].disablerule==true"
                                                                                        autocomplete="off" readonly
                                                                                        value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                                        class="delivery_data qivccount form-control dynvacinedoses"
                                                                                        id="qivcfirst[{{i}}][{{j}}]"
                                                                                        name="createOrderData[{{i}}].createOrderProductData[1].createOrderDeliverySlotData[{{j}}].quantity" /><span
                                                                                        class="glyphicon form-control-erroricon"></span>
                                                                                </td>
                                                                            </ng-template>

                                                                        </ng-container>

                                                                        <td class="gapdose">
                                                                            <div class="totalcost">Total (ex VAT)</div>
                                                                        </td>
                                                                        <td class="deliveryallocated_input dosesbox">
                                                                            <input type="text" autocomplete="off"
                                                                                readonly
                                                                                value="{{prodData.qty | number}}"
                                                                                class="  delivery_data qivcallocated form-control dynallacted"
                                                                                id="qivcallocated[{{i}}]"
                                                                                name="deliveryweek.qivcallocated[{{i}}]"
                                                                                readonly />
                                                                            <div *ngIf="seasonValue!=prepreseason">
                                                                                <input autocomplete="off"
                                                                                    class=" delivery_data aqivtotal form-control "
                                                                                    name="deliveryweek.qivctotalcost[{{i}}]"
                                                                                    id="totalcostqivc[{{i}}]"
                                                                                    value="&#163;{{prodData.qty * reviewPageData?.productList[1]?.priceData?.value | number:'1.2'}}"
                                                                                    readonly />
                                                                            </div>
                                                                        </td>
                                                                        <!--<td class="deliverydate_input dosesbox "><input type="number" 
                                                                                autocomplete="off" class=" delivery_data qivctotal form-control"
                                                                                id="qivctotal[{{i}}]" value={{product.deliverySlots[j].quantity}} readonly /></td>
                                                                        <td class="greentick" >
                                                                        </td> -->
                                                                    </tr>
                                                                    <tr class="qivcyear">

                                                                        <td colspan="15" class="errorarea">
                                                                        </td>
                                                                    </tr>


                                                                </ng-container>
                                                            </ng-container>
                                                            <tr>
                                                                @if(seasonValue!=prepreseason){
                                                                @if(seasonValue==inseason){
                                                                <td colspan="8"></td>
                                                                }@else{
                                                                <td colspan="9"></td>
                                                                }
                                                                <td colspan="4">
                                                                    <div class="totalcostlocation">Total Cost (ex VAT)
                                                                    </div>
                                                                </td>
                                                                <td class="loactionlevelcost">
                                                                    <div><input autocomplete="off"
                                                                            class=" delivery_data aqivtotal form-control "
                                                                            name="deliveryweek.totalcost[{{i}}]"
                                                                            id="totalcost[{{i}}]"
                                                                            value="&#163;{{location.prodCost}}"
                                                                            readonly /></div>
                                                                </td>
                                                                }@else{
                                                                <td colspan="15" class="pricetext">
                                                                    {{reviewcontent?.LargeText4}}</td>
                                                                }
                                                            </tr>




                                                        </table>




                                                    </div>


                                                </div>
                                            </div>
                                        </div>


                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- User info starts -->
                </div>
                <input type="hidden" name="createOrderData[1].sorNumber" value="">
                <input type="hidden" name="createOrderData[1].creditDays" value="120">
                <input type="hidden" name="createOrderData[1].locID" value="60149134">
            </div>
            <div>
                <input type="hidden" name="CSRFToken" value="e21a9d3d-fa32-4dd8-bd3a-3b3731da1b6c">
            </div>
        </div>
        <div class="clearboth"></div>
        <!-- confirm order section starts -->
        <!-- <div class=" col-md-12 finaltotal " *ngIf="seasonValue!=prepreseason">Grand Total: £{{totalCost}}</div> -->
        <div class="bottomBG col-xs-12 no-pad" *ngIf="seasonValue!=prepreseason ">
            @if(isAsAgent && seasonValue==inseason){
                <div class="col-xs-12 OM_tableBottomBtn">

                    <div class="col-xs-12 col-md-12 no-padding" *ngIf="!reviewPageData?.confirmedOrder">
                        <div class="bootom_headerText col-xs-12">Confirm order on behalf of the customer</div>
                    </div>
    
    
                </div>
                    
                <div class="asmreceived col-xs-12" *ngIf="isAsAgent">
                    <div class="revicedheader">Request received by:</div>
                    <div class="checkfeild">
                        <input type="checkbox" id="receivedviaemail" name="received" 
                            [checked]="isReceivedSelected('Email')" value="Email" (change)="checkboxtoggle('Email');asminputcheck(received,'received');checkForErrrors()"
                            class="square-radio"><label class="receivedlabel" for="receivedviaemail">Email</label>
                    </div>
                    <div class="checkfeild">
                        <input type="checkbox" id="receivedviaphone" name="received" 
                            [checked]="isReceivedSelected('Phone')" value="Phone" (change)="checkboxtoggle('Phone');asminputcheck(received,'received');checkForErrrors()"
                            class="square-radio">
                        <label class="receivedlabel" for="receivedviaphone">Phone</label>
                    </div>
    
    
                </div>
                <div *ngIf="receivederror && isAsAgent" class="reveciedblock">
                    <label id="asmerror" class="error help-block" for="received" >
                        {{receivederror}}</label>
                </div>
                <div class="col-xs-12 asmfeild" *ngIf="isAsAgent">
    
    
    
                   <!--  <div class="inputParent col-xs-12 no-pad" [ngClass]="dateerror ? 'has-error' : ''">
                        <label class="prelabel">Date Request Received:*</label> <input type="text" name="datepicker"
                            class="form-control" id="datepicker" value="" autocomplete="no" [(ngModel)]="date">
                        <span class="glyphicon form-control-feedback glyphicon-exclamation-sign" *ngIf="dateerror"></span>
                        <label id="dateerrpr" class="error help-block" for="datepicker" *ngIf="dateerror">
                            please enter date</label>
                    </div> -->
    
                    <!-- <mat-form-field appearance="outline">
    
                        <mat-label>Select Date</mat-label>
                  <input  matInput  [matDatepicker]="picker" 7 [min]="minDate"  [max]="maxDate" 
                            (click)="picker.open()" readonly>
    
                        <mat-datepicker #picker></mat-datepicker>
    
                    </mat-form-field> -->
                    <div  class="inputParent col-xs-5 no-pad date-picker-wrapper "  [ngClass]="dateerror ? 'has-error' : ''">
                        <label class="asmprelabel">Date Request Received: *</label>
                        <input type="text" class="date-input form-control asminput"  
                            [value]="selectedDate ? formatDate(selectedDate) : ''" (click)="toggleCalendar()" readonly />
                            <span class="glyphicon form-control-feedback glyphicon-exclamation-sign asmerroricon" *ngIf="dateerror"></span>
                            <label id="dateerrpr" class="error help-block" for="datepicker" *ngIf="dateerror">
                                {{dateerror}}</label>
    
    
                        <div class="calendar-popup" *ngIf="showCalendar">
    
                            <!-- Header -->
    
                            <div class="calendar-header">
    
                                <button class="nav-btn" (click)="previousMonth()" [disabled]="isPrevDisabled()">
    
                                    ❮ Previous
    
                                </button>
    
    
    
                                <div class="month-title">
    
                                    {{ monthNames[currentMonth] }} {{ currentYear }}
    
                                </div>
    
    
    
                                <button class="nav-btn" (click)="nextMonth()" [disabled]="isNextDisabled()">
    
                                    Next ❯
    
                                </button>
    
                            </div>
    
    
    
                            <!-- Week Days -->
    
                            <div class="weekdays">
    
                                <div *ngFor="let day of weekDays">
    
                                    {{ day }}
    
                                </div>
    
                            </div>
    
    
    
                            <!-- Days -->
    
                            <div class="days-grid">
    
                                <div *ngFor="let day of calendarDays" class="day" [class.empty]="!day"
                                    [class.disabled]="day && !day.selectable" [class.selected]="
                        
                        day &&
                        
                        selectedDate &&
                        
                        day.date.toDateString() === selectedDate.toDateString()
                        
                        " (click)="day && selectDate(day)">
    
                                    {{ day?.day }}
    
                                </div>
    
                            </div>
    
                        </div>
    
                    </div>
                    <div class="col-xs-12 no-pad">
                    <div class="inputParent col-xs-5 no-pad" [ngClass]="nameasmerror ? 'has-error' : ''">
                        <label class="asmprelabel">Name of customer: *</label> <input type="text" name="asmname"(keyup)="checkForErrrors()" (ngModelChange)="asminputcheck($event,'asmname')"
                            class="form-control asminput" id="asmname" value="" autocomplete="no" [(ngModel)]="nameasm">
                        <span class="glyphicon form-control-feedback glyphicon-exclamation-sign asmerroricon"
                            *ngIf="nameasmerror"></span>
                        <label id="asmerror" class="error help-block" for="asmname" *ngIf="nameasmerror">
                            {{nameasmerror}}</label>
                    </div>
                </div>
    
    
                </div>
    
                <div class="col-xs-12 col-md-12 OM_confirmBtnParent inseason_OM_ConfirmBtnParent">
                    <ng-container *ngIf="!reviewPageData?.confirmedOrder">
                        <div class="main_checkboxparent col-md-10 margin-B20">
                            <label class="checkbox-button"> <input type="checkbox" name="" [(ngModel)]="isChecked"
                                    (click)="asmhandleOnCommonCheckboxvalueChange($event)" class="review_checkbox mainCheck" id="">
                                <span class="checkbox-button_control"></span>
                            </label> <label class="mainCheckText ">I confirm that I have permission from the customer to place this order on
                                their behalf.
                            </label>
                        </div>
                    </ng-container>
                    <button class="OM_confirmOrderBtn prvntDoubleClick" [disabled]="!isChecked || !isAllFieldsValid"
                        (click)="handleOnOrderClick('confirmOrder')">{{"startorderUk.reviewpage.confirmorder" |
                        cxTranslate}}</button>
                </div>
    
               
              
                


            }@else{
            
            <div class="col-xs-12 OM_tableBottomBtn">

                <div class="col-xs-12 col-md-12 no-padding" *ngIf="!reviewPageData?.confirmedOrder">
                    <div class="bootom_headerText">Confirm your order to secure your delivery slot for the&nbsp;<span
                            class="reviewseasontxt">{{seasonValue | seasonspilt}}</span>&nbsp;<ng-container
                            *ngIf="seasonValue == inseason">flu </ng-container>season</div>
                    <ng-container *ngIf="seasonValue == inseason;else otheractiveseason">
                        <div class="main_checkboxparent col-md-10 margin-B20">
                            <label class="checkbox-button"> <input type="checkbox" name="" [(ngModel)]="isChecked"
                                    (click)="handleOnCommonCheckboxvalueChange($event)"
                                    class="review_checkbox mainCheck" id="">
                                <span class="checkbox-button_control"></span>
                            </label> <label class="mainCheckText ">{{"startorderUk.byconfirm" | cxTranslate}} <a
                                    href="/termsOfSale" target="_blank" class="showPopupclick">{{"startorderUk.term" |
                                    cxTranslate}}</a>.
                            </label>
                        </div>
                    </ng-container>
                    <ng-template #otheractiveseason>
                        <div class="main_checkboxparent col-md-11 no-padding">
                            <label class="checkbox-button"> <input type="checkbox" name="" [(ngModel)]="isChecked"
                                    (click)="handleOnCommonCheckboxvalueChange($event)"
                                    class="review_checkbox mainCheck" id="">
                                <span class="checkbox-button_control"></span>
                            </label> <label class="mainCheckText">{{"startorderUk.byconfirm" | cxTranslate}} <a
                                    href="/termsOfSale" target="_blank" class="showPopupclick"><b>{{"startorderUk.term"
                                        | cxTranslate}}</b></a>,
                                {{"startorderUk.confirmordertxt2" | cxTranslate}}
                                {{reviewdelivery}}&nbsp;{{"startorderUk.confirmordertxt3" | cxTranslate}}.</label>
                        </div>
                    </ng-template>


                </div>


            </div>

            <div class="col-xs-12 col-md-12 prepreseaoncheck">
                <div class="main_checkboxparent col-md-11 no-padding">
                    <label class="checkbox-button"> <input type="checkbox" name="" [(ngModel)]="materialcheck"
                            class="review_checkbox mainCheck materialcheck" id="">
                        <span class="checkbox-button_control"></span>
                    </label> <label class="mainCheckText">{{reviewcontent?.h2content}}
                    </label>
                </div>


            </div>

            <div class="col-xs-12 col-md-12 OM_confirmBtnParent">
                <button class="OM_confirmOrderBtn prvntDoubleClick" [disabled]="!isChecked || !isAllFieldsValid"
                    (click)="handleOnOrderClick('confirmOrder')">{{"startorderUk.reviewpage.confirmorder" |
                    cxTranslate}}</button>
            </div>

            <div class="col-xs-12 OM_selectline" *ngIf="!reviewPageData?.saveOrderClosed"></div>
            <div class="clearboth"></div>
            <!-- save order section -->
            <div class="saveParent" *ngIf="!reviewPageData?.saveOrderClosed">
                <div class="saveOrderSection">
                    <div class="col-xs-12 col-md-10 saveText">{{"startorderUk.reviewpage.saveordermsg" | cxTranslate}}
                    </div>
                    <button class="OM_saveOrderBtn prvntDoubleClick" [disabled]="!isAllFieldsValid"
                        (click)="handleOnOrderClick('OrderPending')">{{"startorderUk.reviewpage.saveorder" |
                        cxTranslate}}</button>
                </div>
            </div>
            <div class="col-xs-12 astericText" *ngIf="seasonValue != inseason"
                [innerHtml]="reviewcontent?.paragraphcontent"></div>
        }
        </div>

        <!-- prepreseason -->
        <div *ngIf="seasonValue==prepreseason" class="col-xs-12">
            <div class="confirmbox col-xs-12">
                <ng-container *ngIf="isAsAgent;else noneasm">
                    <div class="confirmtext">Confirming the pre-order delivery slot for the {{prepreseason |
                        seasonspilt}} flu season</div>

                    <button class="prepreconfimrbtn" [disabled]="!isAllFieldsValid"
                        (click)="handleOnOrderClick('OrderPending')">Send order to the customer</button>

                </ng-container>
                <ng-template #noneasm>
                    <div class="confirmtext">Confirm your delivery slot for your pre-order to secure your {{prepreseason
                        | seasonspilt}} flu season</div>

                    <div class="col-xs-12 col-md-12 prepreseaoncheck">
                        <div class="main_checkboxparent col-md-11 no-padding">
                            <label class="checkbox-button"> <input type="checkbox" name="" [(ngModel)]="materialcheck"
                                    class="review_checkbox mainCheck materialcheck" id="">
                                <span class="checkbox-button_control"></span>
                            </label> <label class="mainCheckText">{{reviewcontent?.h2content}}
                            </label>
                        </div>


                    </div>
                    <button class="prepreconfimrbtn" [disabled]="!isAllFieldsValid"
                        (click)="handleOnOrderClick('confirmOrder')">Confirm Order</button>
                    <div class="col-xs-12 astericText" [innerHtml]="reviewcontent?.LargeText3"></div>
                </ng-template>

            </div>
        </div>

        <!-- provisional order -->
        <div class="clearboth"></div>
        <!-- <div class="provisionalbottomBG">
            <div class="col-xs-12 OM_tableBottomBtn protablebottom">
                <div class="col-xs-12 col-md-8">
                    <div class="bootom_headerText no-margin-bottom">Save your <span
                            class="reviewseasontxt">2024/25</span> provisional order</div>
                    <div class="col-md-10 no-padding margin-T10 ProvisionalReviewSubtext">
                        Once the&nbsp;2024/25&nbsp;flu season ordering opens in August 2024, a final order will be
                        emailed to you outlining full commercial terms</div>
                </div>
                <div class="col-xs-12 col-md-4 saveOrderSection provisionalsection">
                    <button class="OM_saveOrderBtn provisionalsave prvntDoubleClick" disabled="">Save Provisional
                        Order</button>
                </div>
            </div>

        </div> -->

        <!-- In Season Order Changes -->
        <!-- <div class="InseasonbottomBG" style="display: block;">
            <div class="col-xs-12 OM_tableBottomBtn protablebottom">
                <div class="col-xs-12 col-md-8">
                    <div class="bootom_headerText">Confirm your order to secure your&nbsp;<span
                            class="reviewseasontxt">2024/25</span>&nbsp;season order</div>
                    <div class="main_checkboxparent col-md-10">
                        <label class="checkbox-button"> <input type="checkbox" name="" value=""
                                class="review_checkbox mainCheck" id="">
                            <span class="checkbox-button_control"></span>
                        </label> <label class="mainCheckText">By confirming my order I agree to the <a
                                href="/termsOfSale" target="_blank" class="showPopupclick">Terms of Sale</a> including
                                {{reviewPageData.priceResponse.SOR}} SOR </label>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4 inseasonsection pr-0">
                    <button class="inseasonbtn prvntDoubleClick" disabled="">Confirm Order</button>
                </div>
            </div>
        </div> -->
        <!--  Closed -->

    </section>



    <!-- new design for preprebook -->

</div>